module.exports = __webpack_public_path__ + "media/images/team/stergiani-2c7e165ff31ec76df984b5c8dda52855.jpg";